/**
 * 新增和修改内容，找 @李鹏 review
 */
import moment from 'moment'
import NP from 'number-precision'

export default function registerGlobalFilters (Vue) {
  // 后端接口返回的图片路径添加域名
  Vue.filter('imgHost', function (value) {
    if (value) {
      let imgHost = window.fe.imgHost
      const isLinkRe = /^((http:\/\/)|(https:\/\/)|(\/\/))/
      if (isLinkRe.test(value)) {
        return value
      } else {
        if (value[0] === '/') {
          return imgHost + value
        } else {
          if (imgHost[imgHost.length - 1] === '/') {
            return imgHost + value
          } else {
            return imgHost + '/' + value
          }
        }
      }
    }
  })

  // Vue.filter('formatTaxRate', (taxRate, emptyText = '——') => {
  //   if (taxRate === null || taxRate === undefined || taxRate === '') {
  //     return emptyText
  //   } else {
  //     return NP.times(taxRate, 100) +  '%'
  //   }
  // })

  Vue.filter('accuracyNumber', function (value, ratio = 2) {
    value = value || 0
    value = value.toString()
    let valueNumber = NP.round(value, ratio)
    // 如果存在小数点 精度转换为0时
    if (value.indexOf('.') !== -1) {
      let varArr = value.split('.')
      // 小数点位数大于精度位数
      if (varArr[varArr.length - 1].length > ratio && valueNumber === 0) {
        return value
      }
    }
    // 精度计算
    value = NP.round(value, ratio).toString()
    const index = value.indexOf('.')
    if (index === -1) {
      value += '.00'
    } else {
      const len = ratio - (value.length - 1 - index)
      for (let i = 0; i !== len; i++) {
        value += '0'
      }
    }
    return value
  })

  // 订单备注过滤imgurl
  // Vue.filter('substituteValue', function (value) {
  //   const reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
  //   if (reg.test(value)) {
  //     return '-'
  //   } else {
  //     return value
  //   }
  // })

  Vue.filter('formatPrice', (value, ratio = 2, emptyText = '0.00', padding = false) => {
    if (value === null || value === undefined || value === '') {
      return emptyText
    } else if (ratio === undefined || ratio === null) {
      return value
    } else {
      const result = parseFloat(NP.round(value, ratio))
      return padding ? result.toFixed(ratio) : result
    }
  })

  Vue.filter('convertTime', function (value, format) {
    if (value) {
      return moment(value).format(format || 'YYYY-MM-DD HH:mm:ss')
    } else {
      return '-'
    }
  })

  // todo 删除，和convertTime重复了
  Vue.filter('getMonthDay', function (value) {
    if (value) {
      return moment(value).format('MM-DD')
    } else {
      return '-'
    }
  })

  /**
   * 已售数量处理·新规则
   * 显示颗粒度为10万
   */
  Vue.filter('getSalesVolume', function (value) {
    if (isNaN(value)) return '-'
    if (value === null) return '0'
    if (value < 100000) return value
    const scale = Math.pow(10, 5)
    const formatValue = value >= Math.pow(10, 7) ? Math.pow(10, 7) : value
    const size = Math.floor(formatValue / scale)
    return `${size}0万+`
  })
}
